/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobilePluginOrderSchema = z.object({
	number: z.int().min(-2147483648).max(2147483647).nullish(),
	external_id: z.uuid().nullish(),
	drinksStatus: z.int(),
	foodStatus: z.int(),
});
